'use client';
import { utmFieldsToPost } from '@/lib/pardot/pardot-tracking-fields';
import { useUtmParams } from '@/lib/useUtmParams';

/**
 * The visit's source (src/lib/useUtmParams.ts) as hidden utm_* inputs for a Pardot form —
 * all five fields when there is a source, none when there isn't (see utmFieldsToPost).
 * None on the server or during hydration; they appear once the captured source is read
 * after mount.
 */
export function UtmHiddenFields() {
  const utmParams = useUtmParams();
  return utmFieldsToPost(utmParams).map(([field, value]) => (
    <input key={field} type="hidden" name={field} value={value} />
  ));
}
